import DocIcon from '../icons/DocIcon';
import InboxIcon from '../icons/InboxIcon';
import PdfIcon from '../icons/PdfIcon';
import StarIcon from '../icons/StarIcon';

// .................................

export const LABEL_CONSTANTS = ['Registered Agent mail', 'PRIME mail'];

const AttachmentsList = [
    {
        id: 1,
        para1: 'Articles of Incorporation',
        para2: '200 KB | pdf',
        icon: <PdfIcon />,
    },
    {
        id: 2,
        para1: 'State Filing',
        para2: '340 KB | docx',
        icon: <DocIcon />,
    },
    {
        id: 3,
        para1: 'Federal EIN Registration',
        para2: '40 KB | pdf',
        icon: <PdfIcon />,
    },
];

export const MAIL_NAV_LIST = [
    {
        id: '2', // keep id as previous and reorder list to appear prime first
        icon: StarIcon,
        label: LABEL_CONSTANTS[1],
        filter: (item) => item.type?.toLowerCase() === 'prime' || !item.type,
    },
    {
        id: '1',
        icon: InboxIcon,
        label: LABEL_CONSTANTS[0],
        filter: (item) => item.type?.toLowerCase() === 'registered agent mail',
    },
];
